import React from "react";
import IMG from "../../../assets/bim/img.png";
export default function Image() {
  return (
    <div className="w-full bg-black flex justify-center pb-20">
      <img src={IMG} alt="bim" className="w-[250px] md:w-[500px]" />
    </div>
  );
}
